/* tslint:disable */
import { Injectable } from '@angular/core';
import { Email } from '../../models/Email';
import { FileStorage } from '../../models/FileStorage';
import { Storage } from '../../models/Storage';
import { StorageAttendance } from '../../models/StorageAttendance';
import { StorageAttendanceLocal } from '../../models/StorageAttendanceLocal';
import { StorageChat } from '../../models/StorageChat';
import { StorageClaim } from '../../models/StorageClaim';
import { StorageCompanyProfile } from '../../models/StorageCompanyProfile';
import { StorageProfile } from '../../models/StorageProfile';
import { StoragePost } from '../../models/StoragePost';
import { Stsmartnoticecomments } from '../../models/Stsmartnoticecomments';
import { Stsmartnoticemember } from '../../models/Stsmartnoticemember';
import { Tsaimaster } from '../../models/Tsaimaster';
import { Register } from '../../models/Register';
import { RegisterOnboarding } from '../../models/RegisterOnboarding';
import { SFAttendance } from '../../models/SFAttendance';
import { SFLeaveRequest } from '../../models/SFLeaveRequest';
import { SFOvertimeRequest } from '../../models/SFOvertimeRequest';
import { Sunfish } from '../../models/Sunfish';
import { Tclmuser } from '../../models/Tclmuser';
import { Tcltrequest } from '../../models/Tcltrequest';
import { Teodempaddress } from '../../models/Teodempaddress';
import { Teodempcompany } from '../../models/Teodempcompany';
import { Teodemppersonal } from '../../models/Teodemppersonal';
import { Teodempsurvey } from '../../models/Teodempsurvey';
import { Teodempsurveydetail } from '../../models/Teodempsurveydetail';
import { Teodsurveyquest } from '../../models/Teodsurveyquest';
import { Teodsurveyquestopt } from '../../models/Teodsurveyquestopt';
import { Teomcompany } from '../../models/Teomcompany';
import { Teomemppersonal } from '../../models/Teomemppersonal';
import { Teomposition } from '../../models/Teomposition';
import { Teomsurveyheader } from '../../models/Teomsurveyheader';
import { Ttadattendance } from '../../models/Ttadattendance';
import { Ttadattstatusdetail } from '../../models/Ttadattstatusdetail';
import { Ttadempgetleave } from '../../models/Ttadempgetleave';
import { Ttadleaverequest } from '../../models/Ttadleaverequest';
import { Ttadleaverequestdetail } from '../../models/Ttadleaverequestdetail';
import { Ttadovtrequest } from '../../models/Ttadovtrequest';
import { Ttadovtrequestdetail } from '../../models/Ttadovtrequestdetail';
import { Ttamleavetype } from '../../models/Ttamleavetype';
import { Ttamshiftdaily } from '../../models/Ttamshiftdaily';
import { Viewemployee } from '../../models/Viewemployee';
import { ViewGoEmp } from '../../models/ViewGoEmp';
import { ViewSearchEmp } from '../../models/ViewSearchEmp';
import { Accessmanagement } from '../../models/Accessmanagement';
import { ViewAttReport } from '../../models/ViewAttReport';
import { Ttadattcorrection } from '../../models/Ttadattcorrection';
import { SFAttCorrectionRequest } from '../../models/SFAttCorrectionRequest';
import { ViewLeaveReport } from '../../models/ViewLeaveReport';
import { ViewOvertimeReport } from '../../models/ViewOvertimeReport';
import { ViewShiftscheduleReport } from '../../models/ViewShiftscheduleReport';
import { ViewCareerReport } from '../../models/ViewCareerReport';
import { ViewEmpReq } from '../../models/ViewEmpReq';
import { ViewLeaveBalanceReport } from '../../models/ViewLeaveBalanceReport';
import { ViewHeadcountGender } from '../../models/ViewHeadcountGender';
import { ViewHeadcountMarital } from '../../models/ViewHeadcountMarital';
import { ViewHeadcountPos } from '../../models/ViewHeadcountPos';
import { SFGenerateLeaveBalance } from '../../models/SFGenerateLeaveBalance';
import { Tsaimembersetting } from '../../models/Tsaimembersetting';
import { SFAttendanceStatus } from '../../models/SFAttendanceStatus';
import { Ttamondutyallowitem } from '../../models/Ttamondutyallowitem';
import { Trmmreimtype } from '../../models/Trmmreimtype';
import { Ttamondutypurposetype } from '../../models/Ttamondutypurposetype';
import { Ttadondutyrequest } from '../../models/Ttadondutyrequest';
import { Ttadondutyrequestdtl } from '../../models/Ttadondutyrequestdtl';
import { TtadondutyrequestdtlAtd } from '../../models/TtadondutyrequestdtlAtd';
import { TtadondutyrequestdtlItem } from '../../models/TtadondutyrequestdtlItem';
import { Ttarondutypurposecomp } from '../../models/Ttarondutypurposecomp';
import { SFOnDuty } from '../../models/SFOnDuty';
import { ViewOndutyPurposeItem } from '../../models/ViewOndutyPurposeItem';
import { Ttamoddestination } from '../../models/Ttamoddestination';
import { SFClaimRequest } from '../../models/SFClaimRequest';
import { SFBusinesstripSetting } from '../../models/SFBusinesstripSetting';
import { SfBusinesstripdeclaration } from '../../models/SfBusinesstripdeclaration';
import { Ttadondutydeclaration } from '../../models/Ttadondutydeclaration';
import { Ttadondutydeclarationdtl } from '../../models/Ttadondutydeclarationdtl';
import { SFLeaveRequestSF6 } from '../../models/SFLeaveRequestSF6';
import { SFRequestInbox } from '../../models/SFRequestInbox';
import { SFOvertimeRequestSF6 } from '../../models/SFOvertimeRequestSF6';
import { Tspostservice } from '../../models/Tspostservice';
import { Tschatservice } from '../../models/Tschatservice';
import { Tsfeedservice } from '../../models/Tsfeedservice';
import { Tscalendarservice } from '../../models/Tscalendarservice';
import { Tsmarketplace } from '../../models/Tsmarketplace';
import { Tschatrealtime } from '../../models/Tschatrealtime';
import { Sfrequestfor } from '../../models/Sfrequestfor';
import { SFAttUploadSF6 } from '../../models/SFAttUploadSF6';
import { Ttadattendancetemp } from '../../models/Ttadattendancetemp';
import { Sfbusinesstripdeclarationsf6 } from '../../models/Sfbusinesstripdeclarationsf6';
import { SFAttCorrectionRequestSf6 } from '../../models/SFAttCorrectionRequestSf6';
import { SFAttendanceSF6 } from '../../models/SFAttendanceSF6';
import { SFPolicy } from '../../models/SFPolicy';
import { SFShiftScheduleSF6 } from '../../models/SFShiftScheduleSF6';
import { SFAnnouncement } from '../../models/SFAnnouncement';
import { Securestorage } from '../../models/Securestorage';
import { ERPsalesCustomer } from '../../models/ERPsalesCustomer';
import { SFShiftSchedule } from '../../models/SFShiftSchedule';
import { SFSearch } from '../../models/SFSearch';
import { SFAttendanceList } from '../../models/SFAttendanceList';
import { Workflow } from '../../models/Workflow';
import { SFShiftDaily } from '../../models/SFShiftDaily';
import { SfRequest } from '../../models/SfRequest';
import { SfPayslip } from '../../models/SfPayslip';
import { SFClaimReport } from '../../models/SFClaimReport';
import { SfPayrollWizard } from '../../models/SfPayrollWizard';
import { SFBankTransferReport } from '../../models/SFBankTransferReport';
import { SFBPJSKSReport } from '../../models/SFBPJSKSReport';
import { SFPayProcess } from '../../models/SFPayProcess';
import { SFBPJSTKReport } from '../../models/SFBPJSTKReport';
import { SFPayPeriod } from '../../models/SFPayPeriod';
import { SFBpjsTkSummaryReport } from '../../models/SFBpjsTkSummaryReport';
import { SFEmployeePayrollData } from '../../models/SFEmployeePayrollData';
import { Sfspt1721i } from '../../models/Sfspt1721i';
import { SFSptMasa } from '../../models/SFSptMasa';
import { StoragePayroll } from '../../models/StoragePayroll';
import { SFPayroll } from '../../models/SFPayroll';
import { SFPayProcessReport } from '../../models/SFPayProcessReport';
import { SFUploadPayComponent } from '../../models/SFUploadPayComponent';
import { SfCareer } from '../../models/SfCareer';
import { SFChangeSpv } from '../../models/SFChangeSpv';
import { SFAttSummary } from '../../models/SFAttSummary';
import { Ttamattstatus } from '../../models/Ttamattstatus';
import { SFShiftDailySF6 } from '../../models/SFShiftDailySF6';
import { SFProfile } from '../../models/SFProfile';
import { SFCompany } from '../../models/SFCompany';
import { SFChangePrivacy } from '../../models/SFChangePrivacy';
import { RegistrationNew } from '../../models/RegistrationNew';
import { SFUploadPayHistory } from '../../models/SFUploadPayHistory';
import { BuilderService } from '../../models/BuilderService';
import { InvitationMember } from '../../models/InvitationMember';
import { SFEBanking } from '../../models/SFEBanking';
import { ERPfinance } from '../../models/ERPfinance';
import { ERPpurchase } from '../../models/ERPpurchase';
import { ERPinventory } from '../../models/ERPinventory';
import { StorageInvitation } from '../../models/StorageInvitation';
import { MarketplaceAccess } from '../../models/MarketplaceAccess';
import { SFSpt1721A1 } from '../../models/SFSpt1721A1';
import { TaskFeedbackService } from '../../models/TaskFeedbackService';
import { SFBusinesstripReport } from '../../models/SFBusinesstripReport';
import { SFOnDutySF6 } from '../../models/SFOnDutySF6';
import { SFOvtCancelRequestSF6 } from '../../models/SFOvtCancelRequestSF6';
import { SFOvtCancelRequest } from '../../models/SFOvtCancelRequest';
import { SFLeaveCancelRequest } from '../../models/SFLeaveCancelRequest';
import { SFLeaveCancelRequestSF6 } from '../../models/SFLeaveCancelRequestSF6';
import { ERPaccounting } from '../../models/ERPaccounting';
import { ERPreport } from '../../models/ERPreport';
import { ERPdataAuth } from '../../models/ERPdataAuth';
import { ERPsalesContract } from '../../models/ERPsalesContract';
import { ERPutil } from '../../models/ERPutil';
import { ERPsalesOrder } from '../../models/ERPsalesOrder';
import { PostService } from '../../models/PostService';
import { CalendarService } from '../../models/CalendarService';
import { FeedService } from '../../models/FeedService';
import { ERPproduction } from '../../models/ERPproduction';
import { ERPfixedAsset } from '../../models/ERPfixedAsset';
import { SFElearningSF6 } from '../../models/SFElearningSF6';
import { SFElearningReport } from '../../models/SFElearningReport';
import { SettingService } from '../../models/SettingService';
import { ERPproformaInvoice } from '../../models/ERPproformaInvoice';
import { ERPsalesBadDebt } from '../../models/ERPsalesBadDebt';
import { ERPsalesPlaning } from '../../models/ERPsalesPlaning';
import { ERPsalesPrepaymentInvoice } from '../../models/ERPsalesPrepaymentInvoice';
import { ERPsalesReturn } from '../../models/ERPsalesReturn';
import { ERPshippingInstruction } from '../../models/ERPshippingInstruction';
import { ERPsalesPrepaymentSettlement } from '../../models/ERPsalesPrepaymentSettlement';
import { ERPsalesDCNote } from '../../models/ERPsalesDCNote';
import { ERPproject } from '../../models/ERPproject';
import { SfgisService } from '../../models/SfgisService';
import { SFPolling } from '../../models/SFPolling';
import { SFSmartfeed } from '../../models/SFSmartfeed';
import { ERPpurchasePrepaymentInvoice } from '../../models/ERPpurchasePrepaymentInvoice';
import { ERPpurchaseContract } from '../../models/ERPpurchaseContract';
import { ERPpurchaseDCNote } from '../../models/ERPpurchaseDCNote';
import { ERPpurchasePrepaymentSettlement } from '../../models/ERPpurchasePrepaymentSettlement';
import { ERPpurchaseReturn } from '../../models/ERPpurchaseReturn';
import { ERPpurchaseCostingSheet } from '../../models/ERPpurchaseCostingSheet';
import { ERPpurchaseReturnRequisition } from '../../models/ERPpurchaseReturnRequisition';
import { ERPinternalInventoryRequisition } from '../../models/ERPinternalInventoryRequisition';
import { ERPinternalInventoryRequisitionReturn } from '../../models/ERPinternalInventoryRequisitionReturn';
import { ERPinventoryAdjustmentValue } from '../../models/ERPinventoryAdjustmentValue';
import { ERPinventoryAdjustment } from '../../models/ERPinventoryAdjustment';
import { ERPitemConversion } from '../../models/ERPitemConversion';
import { ERPtransferOrder } from '../../models/ERPtransferOrder';
import { SFAttValidation } from '../../models/SFAttValidation';
import { LeaderBoard } from '../../models/LeaderBoard';
import { SFAppraisal } from '../../models/SFAppraisal';
import { SFClaimCancelRequest } from '../../models/SFClaimCancelRequest';
import { ViewEmpOvtReport } from '../../models/ViewEmpOvtReport';
import { SFLoanRequest } from '../../models/SFLoanRequest';
import { SFLoanRequestSF6 } from '../../models/SFLoanRequestSF6';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Email: Email,
    FileStorage: FileStorage,
    Storage: Storage,
    StorageAttendance: StorageAttendance,
    StorageAttendanceLocal: StorageAttendanceLocal,
    StorageChat: StorageChat,
    StorageClaim: StorageClaim,
    StorageCompanyProfile: StorageCompanyProfile,
    StorageProfile: StorageProfile,
    StoragePost: StoragePost,
    Stsmartnoticecomments: Stsmartnoticecomments,
    Stsmartnoticemember: Stsmartnoticemember,
    Tsaimaster: Tsaimaster,
    Register: Register,
    RegisterOnboarding: RegisterOnboarding,
    SFAttendance: SFAttendance,
    SFLeaveRequest: SFLeaveRequest,
    SFOvertimeRequest: SFOvertimeRequest,
    Sunfish: Sunfish,
    Tclmuser: Tclmuser,
    Tcltrequest: Tcltrequest,
    Teodempaddress: Teodempaddress,
    Teodempcompany: Teodempcompany,
    Teodemppersonal: Teodemppersonal,
    Teodempsurvey: Teodempsurvey,
    Teodempsurveydetail: Teodempsurveydetail,
    Teodsurveyquest: Teodsurveyquest,
    Teodsurveyquestopt: Teodsurveyquestopt,
    Teomcompany: Teomcompany,
    Teomemppersonal: Teomemppersonal,
    Teomposition: Teomposition,
    Teomsurveyheader: Teomsurveyheader,
    Ttadattendance: Ttadattendance,
    Ttadattstatusdetail: Ttadattstatusdetail,
    Ttadempgetleave: Ttadempgetleave,
    Ttadleaverequest: Ttadleaverequest,
    Ttadleaverequestdetail: Ttadleaverequestdetail,
    Ttadovtrequest: Ttadovtrequest,
    Ttadovtrequestdetail: Ttadovtrequestdetail,
    Ttamleavetype: Ttamleavetype,
    Ttamshiftdaily: Ttamshiftdaily,
    Viewemployee: Viewemployee,
    ViewGoEmp: ViewGoEmp,
    ViewSearchEmp: ViewSearchEmp,
    Accessmanagement: Accessmanagement,
    ViewAttReport: ViewAttReport,
    Ttadattcorrection: Ttadattcorrection,
    SFAttCorrectionRequest: SFAttCorrectionRequest,
    ViewLeaveReport: ViewLeaveReport,
    ViewOvertimeReport: ViewOvertimeReport,
    ViewShiftscheduleReport: ViewShiftscheduleReport,
    ViewCareerReport: ViewCareerReport,
    ViewEmpReq: ViewEmpReq,
    ViewLeaveBalanceReport: ViewLeaveBalanceReport,
    ViewHeadcountGender: ViewHeadcountGender,
    ViewHeadcountMarital: ViewHeadcountMarital,
    ViewHeadcountPos: ViewHeadcountPos,
    SFGenerateLeaveBalance: SFGenerateLeaveBalance,
    Tsaimembersetting: Tsaimembersetting,
    SFAttendanceStatus: SFAttendanceStatus,
    Ttamondutyallowitem: Ttamondutyallowitem,
    Trmmreimtype: Trmmreimtype,
    Ttamondutypurposetype: Ttamondutypurposetype,
    Ttadondutyrequest: Ttadondutyrequest,
    Ttadondutyrequestdtl: Ttadondutyrequestdtl,
    TtadondutyrequestdtlAtd: TtadondutyrequestdtlAtd,
    TtadondutyrequestdtlItem: TtadondutyrequestdtlItem,
    Ttarondutypurposecomp: Ttarondutypurposecomp,
    SFOnDuty: SFOnDuty,
    ViewOndutyPurposeItem: ViewOndutyPurposeItem,
    Ttamoddestination: Ttamoddestination,
    SFClaimRequest: SFClaimRequest,
    SFBusinesstripSetting: SFBusinesstripSetting,
    SfBusinesstripdeclaration: SfBusinesstripdeclaration,
    Ttadondutydeclaration: Ttadondutydeclaration,
    Ttadondutydeclarationdtl: Ttadondutydeclarationdtl,
    SFLeaveRequestSF6: SFLeaveRequestSF6,
    SFRequestInbox: SFRequestInbox,
    SFOvertimeRequestSF6: SFOvertimeRequestSF6,
    Tspostservice: Tspostservice,
    Tschatservice: Tschatservice,
    Tsfeedservice: Tsfeedservice,
    Tscalendarservice: Tscalendarservice,
    Tsmarketplace: Tsmarketplace,
    Tschatrealtime: Tschatrealtime,
    Sfrequestfor: Sfrequestfor,
    SFAttUploadSF6: SFAttUploadSF6,
    Ttadattendancetemp: Ttadattendancetemp,
    Sfbusinesstripdeclarationsf6: Sfbusinesstripdeclarationsf6,
    SFAttCorrectionRequestSf6: SFAttCorrectionRequestSf6,
    SFAttendanceSF6: SFAttendanceSF6,
    SFPolicy: SFPolicy,
    SFShiftScheduleSF6: SFShiftScheduleSF6,
    SFAnnouncement: SFAnnouncement,
    Securestorage: Securestorage,
    ERPsalesCustomer: ERPsalesCustomer,
    SFShiftSchedule: SFShiftSchedule,
    SFSearch: SFSearch,
    SFAttendanceList: SFAttendanceList,
    Workflow: Workflow,
    SFShiftDaily: SFShiftDaily,
    SfRequest: SfRequest,
    SfPayslip: SfPayslip,
    SFClaimReport: SFClaimReport,
    SfPayrollWizard: SfPayrollWizard,
    SFBankTransferReport: SFBankTransferReport,
    SFBPJSKSReport: SFBPJSKSReport,
    SFPayProcess: SFPayProcess,
    SFBPJSTKReport: SFBPJSTKReport,
    SFPayPeriod: SFPayPeriod,
    SFBpjsTkSummaryReport: SFBpjsTkSummaryReport,
    SFEmployeePayrollData: SFEmployeePayrollData,
    Sfspt1721i: Sfspt1721i,
    SFSptMasa: SFSptMasa,
    StoragePayroll: StoragePayroll,
    SFPayroll: SFPayroll,
    SFPayProcessReport: SFPayProcessReport,
    SFUploadPayComponent: SFUploadPayComponent,
    SfCareer: SfCareer,
    SFChangeSpv: SFChangeSpv,
    SFAttSummary: SFAttSummary,
    Ttamattstatus: Ttamattstatus,
    SFShiftDailySF6: SFShiftDailySF6,
    SFProfile: SFProfile,
    SFCompany: SFCompany,
    SFChangePrivacy: SFChangePrivacy,
    RegistrationNew: RegistrationNew,
    SFUploadPayHistory: SFUploadPayHistory,
    BuilderService: BuilderService,
    InvitationMember: InvitationMember,
    SFEBanking: SFEBanking,
    ERPfinance: ERPfinance,
    ERPpurchase: ERPpurchase,
    ERPinventory: ERPinventory,
    StorageInvitation: StorageInvitation,
    MarketplaceAccess: MarketplaceAccess,
    SFSpt1721A1: SFSpt1721A1,
    TaskFeedbackService: TaskFeedbackService,
    SFBusinesstripReport: SFBusinesstripReport,
    SFOnDutySF6: SFOnDutySF6,
    SFOvtCancelRequestSF6: SFOvtCancelRequestSF6,
    SFOvtCancelRequest: SFOvtCancelRequest,
    SFLeaveCancelRequest: SFLeaveCancelRequest,
    SFLeaveCancelRequestSF6: SFLeaveCancelRequestSF6,
    ERPaccounting: ERPaccounting,
    ERPreport: ERPreport,
    ERPdataAuth: ERPdataAuth,
    ERPsalesContract: ERPsalesContract,
    ERPutil: ERPutil,
    ERPsalesOrder: ERPsalesOrder,
    PostService: PostService,
    CalendarService: CalendarService,
    FeedService: FeedService,
    ERPproduction: ERPproduction,
    ERPfixedAsset: ERPfixedAsset,
    SFElearningSF6: SFElearningSF6,
    SFElearningReport: SFElearningReport,
    SettingService: SettingService,
    ERPproformaInvoice: ERPproformaInvoice,
    ERPsalesBadDebt: ERPsalesBadDebt,
    ERPsalesPlaning: ERPsalesPlaning,
    ERPsalesPrepaymentInvoice: ERPsalesPrepaymentInvoice,
    ERPsalesReturn: ERPsalesReturn,
    ERPshippingInstruction: ERPshippingInstruction,
    ERPsalesPrepaymentSettlement: ERPsalesPrepaymentSettlement,
    ERPsalesDCNote: ERPsalesDCNote,
    ERPproject: ERPproject,
    SfgisService: SfgisService,
    SFPolling: SFPolling,
    SFSmartfeed: SFSmartfeed,
    ERPpurchasePrepaymentInvoice: ERPpurchasePrepaymentInvoice,
    ERPpurchaseContract: ERPpurchaseContract,
    ERPpurchaseDCNote: ERPpurchaseDCNote,
    ERPpurchasePrepaymentSettlement: ERPpurchasePrepaymentSettlement,
    ERPpurchaseReturn: ERPpurchaseReturn,
    ERPpurchaseCostingSheet: ERPpurchaseCostingSheet,
    ERPpurchaseReturnRequisition: ERPpurchaseReturnRequisition,
    ERPinternalInventoryRequisition: ERPinternalInventoryRequisition,
    ERPinternalInventoryRequisitionReturn: ERPinternalInventoryRequisitionReturn,
    ERPinventoryAdjustmentValue: ERPinventoryAdjustmentValue,
    ERPinventoryAdjustment: ERPinventoryAdjustment,
    ERPitemConversion: ERPitemConversion,
    ERPtransferOrder: ERPtransferOrder,
    SFAttValidation: SFAttValidation,
    LeaderBoard: LeaderBoard,
    SFAppraisal: SFAppraisal,
    SFClaimCancelRequest: SFClaimCancelRequest,
    ViewEmpOvtReport: ViewEmpOvtReport,
    SFLoanRequest: SFLoanRequest,
    SFLoanRequestSF6: SFLoanRequestSF6
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SDKModels.ts